export default {
  tooltip_formula:
    'É necessário salvar o registro antes de adicionar a formula',
  titulos: {
    listagem: 'Fórmulas',
    novo: 'Nova Fórmula',
    editar: 'Editar Fórmula',
    visualizar: 'Visualizar Fórmula',
    visualizar_revisao_formulas: 'Visualizar Revisões - Fórmula ',
    revisao: 'Revisão',
  },
  revisao_excluida_sucesso: 'Revisão excluída com sucesso',
  cadastro_sucesso: 'Fórmula salva com sucesso!',
  exclusao_sucesso: 'Fórmula excluída com sucesso!',
  duplicada_sucesso: 'Fórmula Duplicada com sucesso!',
  erro_exclusao_flag_sistema: 'Não é possível excluir fórmulas do sistema',
  botoes: {
    visualizar_revisoes: 'Visualizar Revisões'
  },
  tabela: {
    codigo: 'Código',
    simbolo: 'Símbolo',
    nome: 'Nome',
    qtdVariaveis: 'Quantidade de Variáveis',
    qtdFormulasDerivadas: 'Quantidade de Fórmulas Derivadas',
    revisaoPublicada: 'Revisão Publicada',
    publicadaEm: 'Publicada em'
  },
  formulario: {
    codigoTag: 'Código: ',
    nome: 'Nome',
    descricao: 'Descrição',
    imagem: 'Adicionar imagem',
    componentes_incerteza_obrigatorio: 'Depende dos Componentes da Incerteza*',
    componentes_incerteza: 'Depende dos Componentes da Incerteza',
    disponivel_criterio_aceitacao: 'Disponível em Critérios de Aceitação*',
    simbolo: 'Símbolo',
    unidadeMedida: 'Unidade de Medida',
    formula: 'Fórmula',
    criada_sistema: 'Criada pelo Sistema',
    justificativa: 'Justificativa',
    variaveis: {
      titulo: 'Variáveis',
      tabela: {
        simbolo: 'Símbolo*',
        unidadeMedida: 'Unidade de Medida',
        formulaCorrecao: 'Fórmula de Correção',
        valorTeste: 'Valor de Teste',
        descricao: 'Descrição',
      },
    },
    abas: {
      dados_formula: 'Dados da Fórmula',
      formulas_derivadas: 'Fórmulas Derivadas',
      clique_salvar_dados: 'Clique para salvar os dados da fórmula'
    }
  },
  filtro: {
    codigo: 'Código',
    nome: 'Nome',
    simbolo: 'Símbolo'
  },
  modal: {
    titulo: 'Validar Fórmula',
    resultado: 'Resultado da fórmula',
    erro: 'Erro',
  },
  modal_formula_derivada: {
    titulo: 'Fórmula Derivada',
    codigo_formula: 'Cód. Fórmula: %{codigo}',
  },
  erros: {
    id_invalido: 'O id da fórmula é inválido',
    criar_formula_derivada: 'Erro ao tentar criar fórmula derivada'
  },
  validacoes: {
    formulario_invalido:
      'É necessário preencher todos os campos da nova fórmula e suas variáveis',
    formula_nao_validada: 'É necessário validar a formula antes de salvar',
    justificativa: 'É necessário informar a justificativa para publicar a revisão',
    simbolo_diferente_mensurando: 'Simbolo deve ser diferente da formula mensurando'
  },
  publicar: {
    titulo: 'Publicar',
    mensagem: 'Deseja realmente publicar revisão?',
    sucesso: 'Revisão publicada com sucesso',
  },
  modal_duplicar: {
    titulo: 'Duplicar Fórmula',
    simboloNaoPodeSerIgual:
      'O símbolo não pode ser igual ao da fórmula original',
    formulario: {
      novo_simbolo: 'Novo Símbolo',
    },
  },
  formulas_derivadas: {
    apresentar_formulas_sistema: 'Apresentar fórmulas criadas pelo sistema',
    botao_nova_formula: 'Nova Fórmula Derivada',
    tabela: {
      codigo: 'Código',
      simbolo: 'Símbolo',
      mome: 'Nome'
    }
  },
  alertas: {
    titulo_mensagem: 'Atenção',
    publicado_automaticamente: 'Lista de códigos revisados e publicados automaticamente',
    incerteza:
      'A revisão selecionada já está publicada. Deseja realmente criar uma nova Revisão e editar esta fórmula?',
  },
  confirmar_edicao_revisao: 'A revisão selecionada já está publicada. Deseja realmente criar uma nova Revisão e editar esta fórmula?'
};
